// import sticky from 'sticky-js';

export default {
  init() {
    var Sticky = require('sticky-js');
    var sticky = new Sticky('.selector');
  }
}
